// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UNMc","option":"styles_option__Ng2WU","active":"styles_active__dz8b5"};